import { render, staticRenderFns } from "./consultantList.vue?vue&type=template&id=0df026d4"
import script from "./consultantList.vue?vue&type=script&lang=js"
export * from "./consultantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports